"use client";

import { useGSAP } from "@gsap/react";
import { ChevronRightIcon } from "@heroicons/react/24/solid";
import { useEffect, useRef, useState } from "react";
import gsap from "gsap";

gsap.registerPlugin(useGSAP);
export default function Accordion(props: AccordionProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { contextSafe } = useGSAP();

  const accordion = useRef<HTMLButtonElement>(null);
  const arrow = useRef<SVGSVGElement>(null);

  const open = contextSafe(() => {
    setIsOpen(true);
    props.onOpen();

    gsap.to(arrow.current, { rotate: 90, duration: 0.5 });
    gsap.to(accordion.current, {
      height: "auto",
      duration: 0.5
    });
  });

  const close = contextSafe(() => {
    setIsOpen(false);

    gsap.to(arrow.current, { rotate: 90 * 2, duration: 0.5 });
    gsap.to(accordion.current, {
      height: 50,
      duration: 0.5
    });
  });

  useEffect(() => {
    if (props.open) {
      open();
      return;
    }
    close();
  }, [props.open, open, close])

  return (
    <button
      ref={accordion}
      onClick={() => { 
        if (isOpen) {
          close();
        } else {
          open();
        }
      }}
      className="sm:max-w-xl w-full border border-neutral-800 rounded-xl px-4 py-3 cursor-pointer space-y-3 h-[50px] overflow-hidden bg-black/20 text-left"
      aria-expanded={isOpen}
      aria-label={`${isOpen ? 'Collapse' : 'Expand'} accordion: ${props.question}`}
    >
      <div className="flex h-max items-center justify-between">
        <h3 className="text-start xs:text-[length:inherit] xs:mt-0 mt-2 text-md text-ellipsis">{props.question}</h3>
        <ChevronRightIcon ref={arrow} className="w-5 h-5 transform rotate-180" aria-hidden="true" />
      </div>
      <p className=" text-white/80 font-light text-start">{props.response}</p>
    </button>
  )
}

type AccordionProps = {
  question: string;
  response: string;
  open: boolean;
  onOpen: () => void;
}